import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { serviceIcon, serviceLabel, STATUS_LABEL, formatZAR } from "@/lib/constants";

export default function JobsList() {
  const { user } = useAuth();
  const [tab, setTab] = useState("nearby");
  const [nearby, setNearby] = useState([]);
  const [mine, setMine] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const [a, b] = await Promise.all([
        api.get("/requests/nearby").catch(() => ({ data: [] })),
        api.get("/requests"),
      ]);
      setNearby(a.data);
      setMine(b.data);
    } finally { setLoading(false); }
  };
  useEffect(() => {
    if (user?.isApproved) load();
    else setLoading(false);
  }, [user]);

  if (user && !user.isApproved) {
    return (
      <div>
        <div className="px-6 pt-8 pb-2">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Mechanic</div>
          <h1 className="font-display text-3xl font-black tracking-tight">Jobs</h1>
        </div>
        <div className="px-6 mt-4">
          <div className="border-2 border-[#E6FF3C] bg-[#E6FF3C]/5 rounded-md p-6" data-testid="jobs-pending-approval">
            <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E6FF3C] font-display mb-2">
              Pending Review
            </div>
            <h2 className="font-display text-xl font-black text-white">Waiting for approval</h2>
            <p className="text-sm text-[#9CA3AF] mt-2">
              You'll see nearby jobs here once your account is approved by our team.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const list = tab === "nearby" ? nearby : mine;

  return (
    <div>
      <div className="px-6 pt-8 pb-2">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#3CFF7E] font-display mb-1">Mechanic</div>
        <h1 className="font-display text-3xl font-black tracking-tight">Jobs</h1>
      </div>

      <div className="px-6 mb-3 grid grid-cols-2 gap-2">
        <TabBtn active={tab === "nearby"} onClick={() => setTab("nearby")} testid="tab-nearby">
          Nearby ({nearby.length})
        </TabBtn>
        <TabBtn active={tab === "mine"} onClick={() => setTab("mine")} testid="tab-mine">
          My Jobs ({mine.length})
        </TabBtn>
      </div>

      <div className="px-6 pb-6">
        {loading ? (
          <div className="text-sm text-[#9CA3AF]">Loading...</div>
        ) : list.length === 0 ? (
          <div className="text-sm text-[#9CA3AF] border border-dashed border-white/20 rounded-md p-8 text-center">
            {tab === "nearby" ? "No pending requests nearby." : "You haven't accepted any jobs yet."}
          </div>
        ) : (
          <div className="space-y-2">
            {list.map((r) => (
              <Link key={r.id} to={`/app/request/${r.id}`} className="block border border-white/10 rounded-md p-4 hover:border-white" data-testid={`job-item-${r.id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex items-start gap-3 flex-1">
                    <div className="text-2xl">{serviceIcon(r.serviceType)}</div>
                    <div className="flex-1 min-w-0">
                      <div className="font-display font-bold">{serviceLabel(r.serviceType)}</div>
                      <div className="text-xs text-[#9CA3AF]">{r.clientName}</div>
                      <div className="text-xs text-[#9CA3AF]">
                        {r.distance_km != null && r.distance_km < 9999
                          ? `${r.distance_km} km away · `
                          : ""}
                        {new Date(r.created_at).toLocaleString()}
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <span className={`status-pill status-${r.status}`}>{STATUS_LABEL[r.status]}</span>
                    <div className="font-display font-bold text-sm mt-2">{formatZAR(r.price)}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function TabBtn({ active, onClick, children, testid }) {
  return (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`h-10 rounded-md font-display font-bold uppercase tracking-wider text-xs ${
        active ? "bg-[#0B1E5B] text-white" : "bg-white/10 text-[#9CA3AF]"
      }`}
    >
      {children}
    </button>
  );
}
